import { GetData } from "../../utils/axios";
import { ADD_USER, LOGOUT, CHANGE_SELECTED_SMVP } from "../constants/user";

export const addUser = (user) => ({
  type: ADD_USER,
  payload: user,
});

export const changeSelectedSmvp = (value) => (dispatch) => {
    if (value === null) {
        localStorage.setItem("selectedSmvp", JSON.stringify(value));
    }
    else {
        localStorage.setItem("selectedSmvp", JSON.stringify(value.storage));
    }
  
  dispatch({
    type: CHANGE_SELECTED_SMVP,
    payload: value,
  });
};

export const refreshSelectedSmvp = (value) => {
  return function (dispatch) {
    return GetData("/samverkanspart/" + value + "?fullObject=true").then(
      (data) => {
            if (data) {

            //Skippa att spara ner till localStorage - id ska redan vara där...Uppdatera bara state på user
          //localStorage.setItem("selectedSmvp", JSON.stringify(value));
                //Lägg ner selectedSamverkanspart ett steg ner så att det stämmer översns med det som finns i changeSelectedSmvp
                let parent = {
                    selectedSamverkanspart: data,
                }

                dispatch({
            type: CHANGE_SELECTED_SMVP,
            payload: parent,
          });
        }
      }
    );
  };
};

export const logoutUser = () => (dispatch) => {
  dispatch({ type: LOGOUT });
};
